import React from 'react';
import { useAgentHubContext } from "../../AgentHub/contexts/AgentHubContext";
import ProductForm from './ProductForm';

const ProductFormWrapper = ({ productId, onSuccess, onCancel }) => {
  const hubContext = useAgentHubContext();
  
  return (
    <ProductForm
      productId={productId}
      onSuccess={onSuccess}
      onCancel={onCancel}
      hubContext={hubContext}
      isInAgentHub={true}
    />
  );
};

export default ProductFormWrapper;